import styled from '@emotion/styled';
import { Box } from '@stenajs-webui/core';
import type { FC } from 'react';
import type { Sailing } from '../../common/graphql/fragments/gql/Sailing';
import { useLocalDateFormat } from '../../common/hooks/useLocalDateFormat';
import type { BookingStatus } from '../../gql/graphql';
import { breakpoints } from '../../themes/defaultTheme';
import { PortDetailsForSailing } from '../PortDetailsForSailing';
import { TripDetails } from '../TripDetails';
import { getShortArrivalInformation } from './utils/getExtendedArrivalInformation';

const Wrapper = styled(Box)`
  justify-content: center;

  @media print, screen and (min-width: ${breakpoints.md}) {
    justify-content: start;
    flex-direction: row;
  }
`;

export const DetailsBox = styled(Box)`
  display: grid;
  grid-template-rows: repeat(3, min-content);
  grid-auto-flow: column;
  gap: var(--swui-metrics-space) calc(2 * var(--swui-metrics-space));
`;

export interface SailingInfoHorizontalProps {
  bookingStatus?: BookingStatus | null;
  hasArrived?: boolean;
  releasedAt?: string | null;
  sailing: Sailing;
}

export const SailingInfoHorizontal: FC<SailingInfoHorizontalProps> = ({
  hasArrived = false,
  releasedAt,
  sailing,
  bookingStatus,
}) => {
  const dateFormat = useLocalDateFormat();
  const arrivalInformation = sailing
    ? getShortArrivalInformation(hasArrived, sailing, dateFormat)
    : null;

  return (
    <Wrapper width={'100%'} gap={[3, 3, 5]} maxWidth={900}>
      <PortDetailsForSailing sailing={sailing} bookingStatus={bookingStatus} />
      <DetailsBox>
        <TripDetails
          releasedAt={releasedAt}
          arrivalInformation={arrivalInformation}
          sailingType={sailing.sailingType}
          shipName={sailing.shipName}
          dateFormat={dateFormat}
        />
      </DetailsBox>
    </Wrapper>
  );
};
